import { render, staticRenderFns } from "./AgreementsDialog.vue?vue&type=template&id=0ce6854c"
import script from "./AgreementsDialog.vue?vue&type=script&lang=js"
export * from "./AgreementsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports